import React, { useMemo } from "react";
import PropTypes from "prop-types";
import { Box, Checkbox, MenuItem, Select } from "@mui/material";
import { filter, find, includes, isEmpty, isNumber, map } from "lodash";
import { Controller } from "react-hook-form";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: { maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP, width: 250 },
  },
};
function CoDropdown({
  control,
  name,
  options,
  mapProps,
  label,
  placeholder = "Please select",
  multiple,
  showCheckbox,
  value: _value,
  onChangeCustom,
  fontSize,
  isDisabled,
  height,
  large,
  ...rest
}) {
  const menuItems = useMemo(() => {
    if (!mapProps) {
      return options;
    } else {
      const [labelProp, valueProp] = mapProps;
      return map(options, (option) => ({
        label: option[labelProp],
        value: option[valueProp],
      }));
    }
  }, [options, mapProps]);

  return (
    <Controller
      name={name}
      control={control}
      render={({ field }) => {
        return (
          <Select
            // disabled={isDisabled}
            {...field}
            displayEmpty
            MenuProps={MenuProps}
            renderValue={() => {
              const { value } = field;
              if (isEmpty(value) && !isNumber(value)) {
                return (
                  <Box sx={{ color: "var(--grey-380)", fontSize: fontSize }}>
                    {placeholder}
                  </Box>
                );
              }

              if (multiple) {
                const selectedLabels = filter(menuItems, (item) =>
                  includes(value, item.value)
                );
                return map(selectedLabels, (item) => item.label).join(", ");
              }

              const selectedLabel = find(menuItems, { value });
              return selectedLabel?.label ?? selectedLabel;
            }}
            select
            value={_value}
            onChange={(e) => {
              if (onChangeCustom) {
                onChangeCustom(e);
              }
              field.onChange(e.target.value);
            }}
            sx={{
              height: large ? "50px" : "44px",
              fontSize: large ? "16px" : "14px",
              "&.root": {
                borderRadius: "8px",
              },
              "&.Mui-disabled": {
                backgroundColor: "#F2F2F2", // Set background color for disabled field
              },
            }}
            {...rest}
          >
            <MenuItem value="" sx={{ fontSize: large ? "16px" : "14px" }}>
              Select
            </MenuItem>
            {map(menuItems, ({ label, value }) => {
              const isSelected = includes(_value, value);
              return (
                <MenuItem key={value} value={value} sx={{ fontSize: "14px" }}>
                  {showCheckbox && <Checkbox checked={isSelected} />}
                  {label}
                </MenuItem>
              );
            })}
          </Select>
        );
      }}
    />
  );
}

CoDropdown.propTypes = {
  multiple: PropTypes.bool,
  showCheckbox: PropTypes.bool,
};

CoDropdown.defaultProps = {
  multiple: false,
  showCheckbox: false,
};
export default CoDropdown;
